export class UserLogged {
  public id: string;
  public role: string;
  public token: string;
  public inactivity: number;

  public static fromJson(json: object): UserLogged {
    const user = new UserLogged();
    user.id = json["id"];
    user.role = json['role'];
    user.token = json['token'];
    return user;
  }
}
